import React from "react";
import { Link } from "react-router-dom";
import { Github, Twitter, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-[var(--ks-border)] bg-white">
      <div className="max-w-[1280px] mx-auto px-4 lg:px-6 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <Link to="/" className="flex items-center">
            <img
              src="/img/etherscan-logo.svg"
              alt="Etherscan"
              className="h-7 w-auto"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.outerHTML = '<div class="font-semibold">Etherscan</div>';
              }}
            />
          </Link>
          <p className="text-sm text-[var(--ks-text-soft)] mt-3">
            The block explorer for the Ethereum blockchain. Fast search, rich detail, and a clean interface for on-chain data.
          </p>
        </div>
        <div>
          <div className="text-sm font-semibold mb-3">Explorer</div>
          <ul className="text-sm space-y-2 text-[var(--ks-text-soft)]">
            <li><Link to="/blocks" className="ks-link" data-testid="footer-blocks">Blocks</Link></li>
            <li><Link to="/txs" className="ks-link" data-testid="footer-txs">Transactions</Link></li>
            <li><Link to="/tokens" className="ks-link" data-testid="footer-tokens">Tokens</Link></li>
            <li><Link to="/contracts" className="ks-link" data-testid="footer-contracts">Verified Contracts</Link></li>
            <li><Link to="/accounts" className="ks-link" data-testid="footer-accounts">Top Accounts</Link></li>
            <li><Link to="/charts" className="ks-link" data-testid="footer-charts">Charts &amp; Stats</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold mb-3">Developers</div>
          <ul className="text-sm space-y-2 text-[var(--ks-text-soft)]">
            <li><Link to="/api-docs" className="ks-link" data-testid="footer-apidocs">API Documentation</Link></li>
            <li><Link to="/rpc" className="ks-link" data-testid="footer-rpc">RPC Endpoint</Link></li>
            <li><Link to="/verify-contract" className="ks-link" data-testid="footer-verify">Contract Verifier</Link></li>
            <li><Link to="/newsletter" className="ks-link" data-testid="footer-newsletter">Newsletter</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold mb-3">Community</div>
          <div className="flex items-center gap-3 text-[var(--ks-text-soft)]">
            <a href="https://etherscani.io" target="_blank" rel="noreferrer noopener" className="ks-link" aria-label="site" data-testid="footer-social-site"><Globe size={18}/></a>
            <a href="https://twitter.com/etherscan" target="_blank" rel="noreferrer noopener" className="ks-link" aria-label="twitter" data-testid="footer-social-twitter"><Twitter size={18}/></a>
            <a href="https://github.com/ethereum" target="_blank" rel="noreferrer noopener" className="ks-link" aria-label="github" data-testid="footer-social-github"><Github size={18}/></a>
          </div>
          <p className="text-xs text-[var(--ks-text-soft)] mt-6">
            © {new Date().getFullYear()} Etherscan. The Ethereum blockchain explorer.
          </p>
        </div>
      </div>
    </footer>
  );
}
